import React from 'react';
import { Tooltip } from 'antd';
import { PW9208Mode } from '../hooks/usePW9208Mode';

interface PW9208Permissions {
  canView: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canExport: boolean;
  canPrint: boolean;
  canApprove: boolean;
  hasAnyPermission: boolean;
}

interface ActionBarProps {
  mode: PW9208Mode;
  isEditing: boolean;
  hasRecord: boolean;
  currentIdx: number;
  allIdsLength: number;
  permissions: PW9208Permissions;
  onAdd: () => void;
  onModify: () => void;
  onDelete: () => void;
  onNavTo: (idx: number) => void;
  onExit: () => void;
}

const PermBtn: React.FC<{
  allowed: boolean;
  disabled: boolean;
  className?: string;
  title?: string;
  onClick?: () => void;
  children: React.ReactNode;
}> = ({ allowed, disabled, className, title, onClick, children }) => {
  const btn = (
    <button
      className={className || 'btn'}
      disabled={disabled || !allowed}
      title={title}
      onClick={onClick}
    >
      {children}
    </button>
  );
  if (!allowed) {
    return <Tooltip title="權限不足">{btn}</Tooltip>;
  }
  return btn;
};

const ActionBar: React.FC<ActionBarProps> = ({
  mode, isEditing, hasRecord,
  currentIdx, allIdsLength,
  permissions,
  onAdd, onModify, onDelete, onNavTo, onExit,
}) => {
  const { canView, canCreate, canEdit, canDelete } = permissions;
  const canSave = mode === 'add' ? canCreate : canEdit;

  return (
    <div className="action-bar">
      <div className="action-group">
        <PermBtn allowed={canView} disabled={isEditing || currentIdx <= 0} onClick={() => onNavTo(0)}>最前</PermBtn>
        <PermBtn allowed={canView} disabled={isEditing || currentIdx <= 0} onClick={() => onNavTo(currentIdx - 1)}>上一筆</PermBtn>
        <PermBtn allowed={canView} disabled={isEditing || currentIdx >= allIdsLength - 1} onClick={() => onNavTo(currentIdx + 1)}>下一筆</PermBtn>
        <PermBtn allowed={canView} disabled={isEditing || currentIdx >= allIdsLength - 1} onClick={() => onNavTo(allIdsLength - 1)}>最後</PermBtn>
      </div>

      <div className="action-group">
        <PermBtn
          allowed={isEditing ? canSave : canCreate}
          disabled={false}
          className="btn btn-primary"
          onClick={onAdd}
        >
          {isEditing ? '存檔' : '新增'}
        </PermBtn>

        <PermBtn
          allowed={isEditing ? true : canEdit}
          disabled={!isEditing && !hasRecord}
          onClick={onModify}
        >
          {isEditing ? '還原' : '修改'}
        </PermBtn>

        <PermBtn
          allowed={canDelete}
          disabled={isEditing || !hasRecord}
          className="btn btn-danger"
          onClick={onDelete}
        >
          刪除
        </PermBtn>

        <div className="action-separator" />
        <button className="btn" onClick={onExit}>離開</button>
      </div>
    </div>
  );
};

export default React.memo(ActionBar);
